import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../../assets/img/svg/save.svg';
import Cancel from '../../../../../assets/img/svg/cancel.svg';
import image from '../../../../../assets/img/svg/Image.svg';
import { Tooltip } from "@material-ui/core";
import { TextField, InputBase, InputAdornment, IconButton, Checkbox } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-autocomplete";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery"
import Delete from '../../../../../assets/img/svg/delete.svg';
import del from "../../../../../assets/img/svg/Del.svg"
import axios from "axios";
import API from "../../../../../_helpers/endpointService";
import moment from "moment";
import { getSettingsFormat } from "../../../../../actions/SettingsAction"
import deactive from '../../../../../assets/img/svg/deactive.svg';

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class AddDISPRO extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            isError: false,
            Docs: [],
            delindex: 0,
            cancel: false,
            DateError: false,
            DescriptionError: false,
            fileUrl: '',
            fileName: '',
            DismantledError: false,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Date": "",
                "Description": "",
                "DismantledTons": "",
                "Title": "",
                "DismantledTonsPercentage": '',
                "LightshipWeight": 0,
                "ModifiedBy": ""
            }
        }
    }

    componentDidMount() {
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.addData.LightshipWeight = parseInt(localStorage.getItem("LightshipWeight"))
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.setState({})
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (this.state.Docs.length != 5) {
            Array.from(e.target.files).forEach(async (a) => {
                let upload = {
                    FileName: a.name,
                    FileSize: a.size,
                    check: false,
                    fdata: a,
                    base64: await this.toBase64(a),
                }
                this.state.Docs.push(upload)
                this.setState({})
            })
        }
        else {
            window.$("#Informationpopup").modal("show")
        }

    };
    Cancel = () => {
        window.$("#Informationpopup").modal("hide")
    }
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    handleInputChange = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (str == "Description") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[str] = e.target.value;
            this.setState({})
        }
    };

    handleInputChange1 = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.value == "") {
            this.state.addData[str] = "";
            this.setState({})
        }
        else {
            this.state.addData[str] = parseFloat(e.target.value);
            this.setState({})
        }
        if (isNaN(this.state.addData[str])) {
            this.state.addData.DismantledTonsPercentage = '';
            this.state.addData[str] = "";
            this.setState({})

        }
        if (this.state.addData.DismantledTons != "") {
            if (this.state.addData.LightshipWeight == 0) {
                this.state.addData.DismantledTonsPercentage = ''
                this.setState({})
            }
            else {
                this.state.addData.DismantledTonsPercentage = parseFloat(this.state.addData.DismantledTons / this.state.addData.LightshipWeight)
                this.state.addData.DismantledTonsPercentage = parseFloat(this.state.addData.DismantledTonsPercentage * 100).toFixed(2)
                this.setState({})
            }

        }
        else {
            this.state.addData.DismantledTonsPercentage = ''
            this.setState({})
        }
    };

    OpenPopup = (i) => {
        this.state.delindex = i;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }

    DeleteItem = () => {
        let tempData = [];
        this.state.Docs.map((i, a) => {
            if (a != this.state.delindex) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }


    setCheckbox = (str) => {
        this.state.Docs.map((i) => {
            if (str == i.fileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#DISPR1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dispro1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dispro").addClass("d-none");
        $("#Dispro").removeClass("d-block");
        $("#DISPL").removeClass("active-color");
        $("#DISPT").removeClass("fw-bolder");
    }
    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

    };
    resize1 = () => {
        $("#DISPR1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dispro1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dispro").removeClass("d-none");
        $("#Dispro").addClass("d-block");
        $("#DISPL").addClass("active-color");
        $("#DISPT").addClass("fw-bolder");
    }
    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate("/dismantlingprogress")
        }

    };
    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/dismantlingprogress")
    };
    AddSave = () => {
        if (this.state.addData.Description.trim() == "") {
            this.state.DescriptionError = true;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        else {
            this.state.DescriptionError = false;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        if (this.state.addData.DismantledTons == "") {
            this.state.DismantledError = true;
            this.setState({})
        }
        else {
            this.state.DismantledError = false;
            this.setState({})
        }
        if (this.state.addData.Date == "") {
            this.state.DateError = true;
            this.setState({})
        }
        else {
            this.state.DateError = false;
            this.setState({})
        }
        if (this.state.addData.Description !== '' && this.state.addData.Date !== '' && this.state.addData.DismantledTons != "") {
            this.props.dispatch({ type: "CANCEL", data: false });
            let formData = new FormData()
            if (this.state.addData.Title != "" || this.state.addData.Title != null) {
                this.state.addData.Title = this.state.addData.Title.trim();
            }
            Array.from(this.state.Docs).forEach(async (a) => {
                formData.append("drawings", a.fdata)
            })
            this.state.addData.Description = this.state.addData.Description.trim()
            this.setState({})
            this.adddwprdocinfo(this.state.addData, formData, this.state.ProjectId)
        }
    }
    adddwprdocinfo = (data, formData) => {
        let apiUrl = API.DISMANTLING_PROGRESS;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.adduploaddwprdocinfo(formData, response.data)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    adduploaddwprdocinfo = (data, id) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.props.navigate("/dismantlingprogress")

                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"DISPR" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="DISPR" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Add New Dismantling Progress</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} pl-3`} onClick={this.AddCancel1} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 ml-2 mt-3">Add New Dismantling Progress</h6>}

                        <div className={this.state.isMobile ? "row mx-1" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right m-0"}>Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>

                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.DateError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "Date") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "Date") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                    }
                                </div>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "d-flex float-end text-right"}>Dismantled Tons&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.DismantledError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            placeholder="0.0"
                                            step="any"
                                            value={this.state.addData.DismantledTons}
                                            onChange={(e) => { this.handleInputChange1(e, "DismantledTons") }}
                                            type="number"
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            type="number"
                                            fullWidth
                                            placeholder="0.0"
                                            step="any"
                                            value={this.state.addData.DismantledTons}
                                            onChange={(e) => { this.handleInputChange1(e, "DismantledTons") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-top" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? "mt-2" : "float-end text-right m-n2"}>%Dismantled&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        placeholder="0"
                                        value={this.state.addData.DismantledTonsPercentage}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1   ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 mt-n3 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : " d-flex float-end text-right m-0"}>Description&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    {this.state.DescriptionError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            multiline
                                            rows={4}
                                            value={this.state.addData.Description}
                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            rows={4}
                                            value={this.state.addData.Description}
                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Description?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Description?.length}/500 Characters left</label>
                                </div>
                            </div>

                            <div className={this.state.isMobile ? "col-12 col-xs-12 pt-4 pb-2 px-3" : "col-12 col-xs-12 pt-4 pb-2 px-1"}>
                                <h6>Drawings</h6>
                            </div>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-top" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Title&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Title}
                                        onChange={(e) => { this.handleInputChange(e, "Title") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={`row mx-1  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "mt-2" : "float-end pt-4 text-right"}>Drawings&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        onChange={(e) => this.UploadFile(e)}
                                        accept=".png,.jpg"
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }} />
                                    <input
                                        type="file"
                                        hidden
                                        multiple="multiple"
                                        accept=".png,.jpg"
                                        onChange={(e) => this.UploadFile(e)}
                                        ref={this.inputFile}
                                    />
                                </div>
                                {/* <div className={`col-12 col-sm-12  col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                    <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                        {this.state.Docs && this.state.Docs.map((i, ind) => {
                                            return (
                                                <div className={`col-12 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-4 " : "col-md-4"}`}>
                                                    <div className="row d-flex">
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" >
                                                            <img className="" src={i.base64} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                            <div className="overflow pt-2 ml-3">{i.fileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.size / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                        </div>
                                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pl-1 mt-2 pt-2 pr-2">
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div> */}
                                <div className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2 px-0 "}`}>

                                {this.state.Docs && this.state.Docs.map((i, ind) => (<>
                                    <div className="text-right pb-1 px-0">
                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind) }} />
                                    </div>
                                    <div className="text-row px-0 pt-2 mb-3 pb-2 text-center">
                                        <img className="img-fluid px-2 " src={i.base64}></img>
                                    </div>
                                </>))}
                            </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="Informationpopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">You can't add more than 5 drawings</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary text-center" : " btn btn-secondary py-2 px-4 text-center"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.Cancel()}><span className="" >Ok</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopup").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>

            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],

    };
}

AddDISPRO.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddDISPRO))
);
